import { Link } from "react-router-dom";

/**
 * Shared footer rendered on all public pages (Landing, Pricing, Why, Solo signup, etc.).
 * Includes the "ArmIQ is a product of BioHacker Sports" attribution per brand-owner direction.
 */
const BIOHACKER_LOGO = "https://customer-assets.emergentagent.com/job_athlete-workload-hub/artifacts/uyv1y0oq_IMG_0362.png";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--ink-border)]" style={{ backgroundColor: "var(--ink-0)" }} data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 py-8 flex flex-col gap-6">
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <div className="text-xs text-white/40">
            © {year} ArmIQ — Healthy Arms. Healthy Bodies. Elite Performance.
          </div>
          <nav className="flex flex-wrap items-center gap-4 text-xs text-white/60">
            <Link to="/terms" className="hover:text-white" data-testid="footer-terms">Terms of Service</Link>
            <Link to="/privacy" className="hover:text-white" data-testid="footer-privacy">Privacy Policy</Link>
            <Link to="/refund-policy" className="hover:text-white" data-testid="footer-refund">Refund Policy</Link>
            <Link to="/pricing" className="hover:text-white">Pricing</Link>
            <Link to="/why" className="hover:text-white">Why ArmIQ</Link>
          </nav>
        </div>
        <div className="pt-6 border-t border-white/5 flex flex-col sm:flex-row sm:items-center sm:justify-end gap-3" data-testid="footer-biohacker">
          <span className="text-[10px] tracking-[0.2em] uppercase text-white/35">ArmIQ is a product of</span>
          <a href="https://biohackersports.com" target="_blank" rel="noopener noreferrer"
             className="inline-flex items-center gap-2 group" data-testid="footer-biohacker-link">
            <img src={BIOHACKER_LOGO} alt="BioHacker Sports" className="h-9 w-auto opacity-90 group-hover:opacity-100 transition" />
          </a>
        </div>
      </div>
    </footer>
  );
}
